module.exports = __webpack_public_path__ + "img/arrow-navigate.28698cf5.svg";